Vue.component('TranslationsIndexComponent', require('./components/TranslationsIndexComponent').default);

window.language = document.querySelector('html').getAttribute('lang');

window.t = function (key, params) {
    let replace = function (string, params) {
        if (params === undefined) {
            return string;
        }

        let data = {};

        _.each(params, (value, key) => {
            if (key[0] !== ':') {
                key = ':' + key;
            }
            data[key] = value;
        });

        let regex = new RegExp(_.keys(data).join('|'), 'gi');

        return string.replace(regex, function (matched) {
            return data[matched];
        });
    };

    let translation = _.get(window.translations, key);

    if (translation === undefined && window.storeMissingTranslations) {
        axios.post(window.translationsRoute, {
            namespace_key: key,
            placeholders: params ? _.keys(params) : [],
        });

        window.translations[key] = key;

        return replace(key, params);
    }

    if (!translation) {
        return replace(key, params);
    }

    return replace(translation, params);
};
